import React, {useCallback, useContext} from 'react';


import {MessageContext} from 'src/contexts/message-context';
import {ValidationContextProvider} from 'src/contexts/validation-context/validation-context-provider';

import {Dialog} from '@pb/kit-component-dialog-v2';

import {ACCOUNT_TEAM_MEMBER_MODAL_WIDTH, AccountTeamMemberEditModal} from './account-team-member-edit-modal';

type Props = {
    accountId: number,
    shown: boolean,
    onClose: () => void,
    onSuccess: () => void,
};

const SUCCESS_MESSAGE = 'Account Team has been successfully updated';

export const AccountTeamMemberEdit: React.FC<Props> = ({accountId, onSuccess, shown, onClose}) => {
    const {setSuccessMessage} = useContext(MessageContext);

    const onSuccessClose = useCallback(() => {
        setSuccessMessage(SUCCESS_MESSAGE);
        onSuccess();
    }, [setSuccessMessage, onSuccess]);

    return (
        <ValidationContextProvider>
            <Dialog
                shown={shown}
                setShown={onClose}
                wrapperProps={{style: {width: ACCOUNT_TEAM_MEMBER_MODAL_WIDTH}}}>
                <AccountTeamMemberEditModal accountId={accountId} onClose={onClose} onSuccessClose={onSuccessClose}/>
            </Dialog>
        </ValidationContextProvider>
    );
};
